import { TeamContent } from './types';

export const teamContent: TeamContent = {
  drJoe: {
    name: "Dr. Joe Rietow, DDS",
    clinic: "Rietow Family Dentistry",
    quote: `"As my patient, you can expect that I will help you achieve the smile that you have always wanted while using the latest technology available in dentistry."`,
    headshot: require('../assets/JoeHeadshot1x1.png'),
  },
};
